import { render, staticRenderFns } from "./menuCategory.vue?vue&type=template&id=76ff9e92&scoped=true"
import script from "./menuCategory.vue?vue&type=script&lang=js"
export * from "./menuCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff9e92",
  null
  
)

export default component.exports